import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.coincap.io/v2",
});

export default instance;
